import { Chunk } from "../../models";

const CHUNK_SIZE = 10485760; // 10 MiB

export class FileServices {
  constructor(public file: File) {}

  chunk(chunkSize: number = CHUNK_SIZE): Array<Chunk> {
    const chunkedFile: Array<Chunk> = [];
    if (this.file.size <= chunkSize) {
      const chunk = this.file.slice(0, this.file.size);
      return [{ chunk, startByte: 0, endByte: this.file.size }];
    }
    for (let offset = 0; offset < this.file.size; offset += chunkSize) {
      const chunk = this.file.slice(offset, offset + chunkSize);
      chunkedFile.push({
        chunk,
        startByte: offset,
        endByte: offset + chunk.size,
      });
    }
    return chunkedFile;
  }
}
